module.exports = __webpack_public_path__ + "static/media/matthew.cbf05bb0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/decoration/img/matthew.jpeg
// module id = 739
// module chunks = 0